import ActiveController from "rapid/controller";
import "styles/styles.scss";

const dependencies = [];
/* eslint-disable */
const favicons = {
	1: require("../images/favicon-32.png"),
	2: require("../images/favicon-180.png"),
	3: require("../images/favicon-270.png"),
	4: require("../images/favicon-512.png"),
	5: require("../images/up_logo.svg")
};
export class AppController extends ActiveController {
	constructor($injector) {
		"ngInject";
		super($injector, dependencies);

		const defaultFormat = "YYYY-MM-DDTHH:mm:ss";

		window.moment.locale("pl");
		window.moment.defaultFormat = defaultFormat;
		window.moment.defaultFormatUtc = defaultFormat;

		this.openedComponent = null;

	}

	isAuthenticated() {
		return this.$auth.isAuthenticated();
	}

}



// WEBPACK FOOTER //
// ./sources/app.controller.js